import { gql } from 'graphql-request';

export interface DeleteGlobalCompanyTabQueryResponse {
  deleteGlobalCompanyTab: {
    status: string;
  };
}

export const DELETE_GLOBAL_COMPANY_TAB_QUERY = gql`
  mutation DeleteGlobalCompanyTab($uid: Uid!) {
    deleteGlobalCompanyTab(uid: $uid) {
      status
    }
  }
`;
